<template>
  <section>
    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="auto">
          <btnregister></btnregister>
          <btnupdate
            v-if="active"
            type="UserList"
            :data="editUser"
            :active="active"
            @dialog:change="eventdialog"
          ></btnupdate>
        </v-col>

        <v-chip-group class="ml-2" v-model="statusFilter" active-class="success">
          <span class="caption my-auto">Filtrar:</span>

          <v-chip class="mx-1" label value="ACTIVE"> Activos </v-chip>
          <v-chip class="mx-1" label value="INACTIVE"> Inactivos </v-chip>
          <v-chip class="mx-1" label value="DELETED"> Eliminados </v-chip>
        </v-chip-group>

        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="users"
        :loading="isLoading"
        :search="search"
        :options.sync="tableOptions"
        :footer-props="{
          'items-per-page-options': [100, 1000],
        }"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title class="primary--text text--darken-1 font-weight-medium">
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-avatar size="40" :color="$vuetify.theme.dark ? 'blue-grey darken-4' : 'blue-grey lighten-5'">
                  <v-img v-if="item.url_image" :src="item.url_image" alt="Avatar del usuario"></v-img>
                  <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title class="primary--text text--darken-1 font-weight-medium">
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-tooltip color="blue-grey" top>
            <template v-slot:activator="{ on }">
              <v-chip v-on="on" color="transparent" small @click="changeStatus(item)">
                <v-icon left small :color="statusColor(item.status)">mdi-radiobox-marked</v-icon>
                {{ item.status | StatusName }}
              </v-chip>
            </template>
            <span>Cambiar estado</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.clients`]="{ item }">
          <span v-if="item.clients.length > 1">Varios</span>
          <span v-else>
            {{ item.clients[0] ? item.clients[0].name : "No posee" }}
          </span>
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleEdit(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'error' : 'blue-grey'" @click.stop="handleDelete(item)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <!-- <v-row justify="end">
      <v-col cols="auto">
        <v-pagination
          circle
          color="primary"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </v-col>
    </v-row> -->
  </section>
</template>

<script>
import { mapState } from "vuex";

import btnregister from "@/components/Users/User/btnregister.vue";
import btnupdate from "@/components/Users/User/btnupdate.vue";

export default {
  name: "IndexUser",

  components: {
    btnupdate,
    btnregister,
  },

  data() {
    return {
      search: "",
      active: false,
      isLoading: false,
      headers: [
        {
          text: "Nombre",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "30%",
        },
        // {
        //     text: "Cliente",
        //     align: "left",
        //     value: "clients",
        //     class: "primary--text",
        //     width: "20%"
        // },
        {
          text: "Estado",
          value: "status",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Rol",
          value: "role.name",
          class: "primary--text",
          width: "15%",
        },
        // {
        //     text: "Creado",
        //     value: "created_at",
        //     class: "primary--text",
        //     width: "15%"
        // },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      tableOptions: {
        page: 1,
        itemsPerPage: 1000,
      },
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      data: [],
      editUser: {},
      statusFilter: null,
    };
  },

  computed: {
    ...mapState("user", ["users"]),
  },

  watch: {
    tableOptions: {
      handler() {
        this.getusers();
      },
      deep: true,
    },
    statusFilter(val) {
      const status = val === "ACTIVE" ? 1 : val === "INACTIVE" ? 0 : undefined;
      const includeDeleted = val === "DELETED" ? true : undefined;
      this.getusers(status, includeDeleted);
    },
  },

  async created() {
    await this.getusers();
  },

  methods: {
    statusColor(status) {
      let color;

      switch (status) {
        case 0:
          color = "error";

          break;

        case 1:
          color = "success";

          break;

        // case 2:
        //   color = "light-blue";

        //   break;

        case 3:
          color = "warning";

          break;
      }
      return color;
    },

    dateFormat(date) {
      const dateFormatted = date
        .toString()
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("/");
      return dateFormatted;
    },

    eventdialog() {
      this.active = false;
    },

    handleEdit(user) {
      this.editUser = {
        id: user.id,
        name: user.name,
        email: user.email,
        password: user.password,
        role_id: user.role_id,
        auto_connection: user.auto_connection,
        extension_opcional: user.extension_opcional,
        enable_queues_chat: user.enable_queues_chat,
      };
      this.active = true;
    },

    async handleDelete(user) {
      try {
        const confirmRequest = await this.$swalconfirm(
          "¿Seguro?",
          `Está seguro de eliminar a ${user.name}. Ésta acción no es reversible`,
        );
        if (confirmRequest.isConfirmed) {
          await this.$store.dispatch("user/DELETE_USER", user.id);

          this.$snotify.success("Usuario eliminado", "¡Hecho!");
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar el usuario.", "¡Error!");
        // console.error(error);
      }
    },

    async getusers(status = undefined, include_deleted = undefined) {
      this.isLoading = true;
      try {
        const { page, itemsPerPage } = this.tableOptions;
        const res = await this.$store.dispatch("user/GET_USERS", {
          params: { page, itemPerPage: itemsPerPage, status, include_deleted },
        });
        this.pageCount = res.last_page;
      } catch (error) {
        this.$snotify.error("No se pudo obtener listado de usuarios.", "¡Error!");
        // console.error(error);
      }
      this.isLoading = false;
    },

    async changeStatus(value) {
      // console.log("Prueba", value);
      const conf = confirm("CAMBIAR ESTATUS");
      if (conf) {
        try {
          if (value.status === 2) {
            await this.$store.dispatch("user/QUIT_PAUSE", {
              id: value.user_pause[0].id,
            });
          } else {
            await this.$store.dispatch("user/CHANGE_STATUS", {
              id: value.id,
            });
          }

          this.$snotify.success("Estatus cambiado con éxito.", "¡Hecho!");

          setTimeout(() => {
            location.reload();
          }, 3000);
        } catch (error) {
          this.$snotify.error("No se pudo cambiar el estado del usuario.", "¡Error!");
          // console.error(error);
        }
      }
    },
  },
};
</script>
